import React, {useEffect, useMemo} from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import 'mdbreact/dist/css/mdb.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './TicketTable.css';
import DataTableTickets from '../DataTableTickets/DataTableTickets';
import DataFilterTickets from '../DataFilterTickets/DataFilterTickets';
import { filterDataTickets } from '../../shared/utilities/filterData.js';
import isFilled from '../../shared/utilities/isFilled';

const TicketTable = (props) => {
    const {user, setTicketsStateSummary, formikValues, setFormikValues, installations, dataTicketsAux, resetTicketFilters, loadingTickets, successTickets, messageTickets} = props
    const navigate = useNavigate();

    const dataTickets = useMemo(() => {
        return isFilled(dataTicketsAux)
            ? filterDataTickets(dataTicketsAux, formikValues)
            : [];
    }, [dataTicketsAux, formikValues]);

    useEffect(() => {
        if(isFilled(dataTicketsAux)){
            setTicketsStateSummary({
                pending: dataTicketsAux.filter(ticketRes => ticketRes.ticket.estado === 'PENDIENTE').length,
                process: dataTicketsAux.filter(ticketRes => ticketRes.ticket.estado === 'PROCESO').length,
                close: dataTicketsAux.filter(ticketRes => ticketRes.ticket.estado === 'CERRADO').length,
            })
        }
    }, [dataTicketsAux, setTicketsStateSummary])

    return(
        <div className = 'container-fluid'>
            <div className = "progress" style = {{height: "20px", display: loadingTickets ? "" : 'none'}}>
                <div className = "progress-bar" role = "progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style = {{width: "25%"}}></div>
            </div>
            <DataFilterTickets user = {user} dataTicketsAux = {dataTicketsAux} formikValues = {formikValues} setFormikValues = {setFormikValues} installations = {installations} resetTicketFilters = {resetTicketFilters} />
            {isFilled(dataTicketsAux) && !loadingTickets
            ?
                <div>
                    {isFilled(dataTickets)
                    ?
                        <DataTableTickets user = {user} dataTickets = {dataTickets} navigate = {navigate} />
                    :   
                        <div><Alert severity="info">{"No existen tickets para estos filtros"}</Alert></div>
                    }
                    
                </div>

            :!isFilled(dataTicketsAux) && !loadingTickets && successTickets
            ?
                <div></div>
                
            :!isFilled(dataTicketsAux) && loadingTickets
            ?
                <div></div>

            :successTickets === false && !loadingTickets
            ?
                <div>
                    <p>{`No es posible obtener la lista de tickets. Mensaje: ${messageTickets}`}</p>
                </div>
            :   
                <div></div>
            }
        </div>
    )
}

export default TicketTable;
